export const VAPID_KEY: Readonly<string> =
  "BHxijM1HJVYvp3fMOJkaz1rAF2lNpRZkmkwhfVOzxm1wCR7afw9ZvfF7eViCBwudGUF_p4rEDMQIqfaAKadqrdU";

export const firebaseConfig = {
  apiKey: "AIzaSyAIDFoHB2AjEpr4fAIxNvJCShGRo_LvXjs",
  authDomain: "edutizim-dev.firebaseapp.com",
  projectId: "edutizim-dev",
  storageBucket: "edutizim-dev.appspot.com",
  messagingSenderId: "675143152960",
  appId: "1:675143152960:web:d6550c63a96d754c27f6a5",
  measurementId: "G-5697815W52",
};
